import TitleTag from "@/components/TitleTag";
import BadgeRow from "@/components/BadgeRow";
import { FlagBadge } from "@/lib/flags";

/**
 * Nameplate — canonical `[Flag][Username][Title][Badges]` row used in
 * leaderboards, profile headers, chat list, etc.
 *
 * Props:
 *  - userId         (required for Title + Badges fetch)
 *  - name           display name
 *  - country        ISO alpha-2 ("US", "JP", ...). Optional.
 *  - avatar         optional URL — when supplied, shown to the left of the name
 *  - size           "sm" | "md" | "lg"
 *  - showTitle      hide the title tag (used inside compact rows that already show it)
 *  - className      extra wrapper classes
 */
export default function Nameplate({
  userId, name, country, avatar, nameColor,
  size = "sm", showTitle = true, className = "",
}) {
  const nameSz = size === "lg" ? "text-base" : size === "md" ? "text-sm" : "text-[11px]";
  const avSz = size === "lg" ? "w-7 h-7" : size === "md" ? "w-6 h-6" : "w-5 h-5";
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`} data-testid={userId ? `nameplate-${userId}` : undefined}>
      {avatar !== undefined && (
        avatar
          ? <img src={avatar} alt="" className={`${avSz} rounded-full object-cover border border-slate-700`}/>
          : <div className={`${avSz} rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center text-[9px] text-slate-500`}>{(name||"?").charAt(0).toUpperCase()}</div>
      )}
      <FlagBadge code={country} size={size}/>
      <span style={nameColor ? { color: nameColor } : undefined} className={`${nameSz} font-bold ${nameColor ? "" : "text-white"}`}>{name}</span>
      {showTitle && userId && <TitleTag userId={userId} size={size}/>}
      {userId && <BadgeRow userId={userId} size={size}/>}
    </span>
  );
}
